export const isHubspotAndroid = window.navigator.userAgent.indexOf('HubSpotAndroid') > -1;
export const isHubSpotNativeApp = window.navigator.userAgent.indexOf('HubSpotiOS') > -1 || isHubspotAndroid;